import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import NontAuthorized401 from "NontAuthorized401";
import NotificationComposer from "./components/Create";

const EmailNotification = () => {
  const hasToken = Boolean(localStorage.getItem("Token"));

  return (
    <>
      {hasToken ? (
        <DashboardLayout>
          <DashboardNavbar />

          <div className="mt-6 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
            <div className="border-b border-slate-200 bg-gradient-to-r from-blue-50 via-white to-indigo-50 p-5 sm:p-6">
              <span className="inline-flex rounded-full border border-blue-200 bg-blue-100 px-3 py-1 text-xs font-semibold text-blue-700">
                Email Channel
              </span>
              <h3 className="mt-3 text-xl font-semibold text-slate-900">Email Notifications</h3>
              <p className="mt-1 text-sm text-slate-600">
                Send targeted email updates to Customers and Partners with module-based delivery.
              </p>
            </div>

            <div className="p-5 sm:p-6">
              <NotificationComposer
                title="Email"
                channel="email"
                endpoint="notification/send-email"
                messageLabel="Email Body"
                submitLabel="Send Email Notification"
              />
            </div>
          </div>
        </DashboardLayout>
      ) : (
        <NontAuthorized401 />
      )}
    </>
  );
};

export default EmailNotification;
